import React from 'react';
import PropTypes from 'prop-types';

import CountDown from '../../lib/components/LessonPath/count-down';

export default class TrailCountDown extends React.Component {
    render() {
        const { level, cid, clickCloseTrailCountDown, data } = this.props;

        return (
            <div className='trail-dialog'>
                <div className='trail-dialog-content'>
                    <div className='trail-title'>学习前提醒</div>
                    <div className='trail-text'>
                        宝贝预约的<span className='orange'>【Level {level} 体验营】</span>将在
                        <CountDown startTime={data.lessonStartTime} systemTime={data.lessonSystime} />
                        后准时开始，在学习之前，请家长完成内容准备。
                </div>
                    <ul>
                        <li>准备安静的学习房间，保证最佳学习效果；</li>
                        <li>避免躺卧学习，让宝贝保持良好的学习坐姿；</li>
                        <li>备齐学习设备，推荐平板电脑，提前充电。</li>
                    </ul>
                    <div className='trail-bottom'>
                        <div
                            onClick={() => {
                                window.location.href = `https://www.putaoabc.com/onlinepages/course_assist/reserve_lesson/?putaoid=${this.context.user.putaoid}&token=${this.context.user.token}&from=${this.context.user.from}&cid=${cid}&source=course`;
                            }}
                            className='trail-left'
                        >
                            改时间
                    </div>
                        <div
                            className='trail-right'
                            onClick={() => clickCloseTrailCountDown()}
                        >
                            去准备
                    </div>
                    </div>

                    <div
                        className='trail-dialog-close'
                        onClick={() => clickCloseTrailCountDown()}
                    />
                </div>
            </div>
        );
    }
}

TrailCountDown.contextTypes = {
    user: PropTypes.object
}




// WEBPACK FOOTER //
// ./src/components/dialog/TrailCountDown.js